<template>
  <div class="footer-action">
    <b-col>
      <router-link v-if="routePath" :to="routePath">
        <b-button class="btn-cancel btn-width">CANCEL</b-button>
      </router-link>
    </b-col>
    <b-col class="text-right">
      <b-button class="main-color btn-save" @click="$emit('submit')">
        Save
      </b-button>
    </b-col>
  </div>
</template>

<script>
export default {
  props: ["routePath"],
  created() {
    document.body.style.setProperty("--margin-bottom", "4rem");
  },
  destroyed() {
    document.body.style.setProperty("--margin-bottom", "0px");
  },
};
</script>

<style>
@media (min-width: 200px) and (max-width: 414px) {
  .footer-action {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
}
.footer-action {
  box-shadow: 0px 5px 0px var(--secondary-color),
    0px 5px 10px var(--secondary-color);
  margin-left: var(--margin-spacing);
  z-index: 2;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: #fff;
  display: flex;
  flex-direction: row;
  transition: margin-left 0.25s, margin-right 0.25s, width 0.25s, flex 0.25s;
}
</style>
